import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useSetupStatus } from "../hooks/useSetupStatus";

interface RequireAuthProps {
  children: JSX.Element;
  skipSetupCheck?: boolean;
}

function RequireAuth({ children, skipSetupCheck = false }: RequireAuthProps) {
  let auth = useAuth();
  let location = useLocation();
  const { needsSetup, isLoading } = useSetupStatus();

  if (!auth.isAuthenticated()) {
    // Redirect them to the /login page, but save the current location they were
    // trying to go to when they were redirected. This allows us to send them
    // along to that page after they login, which is a nicer user experience
    // than dropping them off on the home page.
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // If setup check is not skipped and user needs setup, redirect to league setup
  // Don't redirect if already on a setup route to avoid loops
  if (
    !skipSetupCheck &&
    !isLoading &&
    needsSetup &&
    !location.pathname.startsWith("/setup")
  ) {
    return <Navigate to="/setup/league" state={{ from: location }} replace />;
  }

  return children;
}

export default RequireAuth;
